import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { SiGoogleplay } from 'react-icons/si';
import { useTranslation } from 'react-i18next';

const ComingSoonContainer = styled.div`
  max-width: 700px;
  margin: 0 auto;
  padding: 2rem;
  text-align: center;
  background: ${({ theme }) => theme.cardBg};
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: ${({ theme }) => theme.textStrong};
`;

const Message = styled.p`
  font-size: 1.2rem;
  line-height: 1.7;
  margin-bottom: 2rem;
  color: ${({ theme }) => theme.text};
`;

const IconContainer = styled.div`
  margin: 2rem 0;
  font-size: 5rem;
  color: #0F9D58; /* Google Play зеленый */
`;

const BackButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  padding: 0.8rem 1.5rem;
  background: ${({ theme }) => theme.primary};
  color: white;
  text-decoration: none;
  border-radius: 10px;
  font-weight: 600;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
  }
  
  svg {
    margin-right: 8px;
  }
`;

const GooglePlayComingSoon = () => {
  const { t } = useTranslation();
  
  return (
    <ComingSoonContainer>
      <IconContainer>
        <SiGoogleplay />
      </IconContainer>
      <Title>{t('comingSoon.googlePlay.title')}</Title>
      <Message>
        {t('comingSoon.googlePlay.description1')}
      </Message>
      <Message>
        {t('comingSoon.googlePlay.description2')}
      </Message>
      <BackButton to="/">
        <FaArrowLeft /> {t('comingSoon.backToHome')}
      </BackButton>
    </ComingSoonContainer>
  );
};

export default GooglePlayComingSoon; 